import { DamsIcon } from '../icons'

// DONE...

export default {
  id: 'dams',
  title: {
    en: 'Dams',
    ar: 'السدود'
  },
  Icon: DamsIcon,
  description: {
    en: `<p>A dam is a barrier that stops or restricts the flow of water. Dams are used to collect water which would then be used for irrigation, livestock, and recreation.</p><p>Jordan’s dams collect most of their water from rainfall, but more than 90% of rainfall evaporates before being captured.</p>`,
    ar: ``
  },
  entries: [
    {
      id: 'dam01',
      position: { x: 451.7, y: 174 },
      title: {
        en: 'Al Wehdah',
        ar: 'الوحدة'
      },
      year: '2011',
      capacity: '110'
    },
    {
      id: 'dam02',
      position: { x: 351.3, y: 249.5 },
      title: {
        en: 'Wadi Al-Arab',
        ar: 'وادي العرب'
      },
      year: '1986',
      capacity: '16.8'
    },
    {
      id: 'dam03',
      position: { x: 351.3, y: 307.9 },
      title: {
        en: 'Ziglab',
        ar: 'زقلاب'
      },
      year: '1965',
      capacity: '3.9'
    },
    {
      id: 'dam04',
      position: { x: 359.6, y: 373.4 },
      title: {
        en: 'Kufranja',
        ar: 'كفرنجة'
      },
      year: '2016',
      capacity: '6'
    },
    {
      id: 'dam05',
      position: { x: 455.9, y: 412.3 },
      title: {
        en: 'King Talal',
        ar: 'الملك طلال'
      },
      year: '1977',
      raised: '1987',
      capacity: '75'
    },
    {
      id: 'dam06',
      position: { x: 351.3, y: 475 },
      title: {
        en: 'Al Karameh',
        ar: 'الكرامة'
      },
      year: '1997',
      capacity: '55'
    },
    {
      id: 'dam07',
      position: { x: 351.3, y: 525.1 },
      title: {
        en: 'Shueib',
        ar: 'شعيب'
      },
      year: '1969',
      capacity: '1.4'
    },
    {
      id: 'dam08',
      position: { x: 358.8, y: 562.7 },
      title: {
        en: 'Kafrein',
        ar: 'الكفرين'
      },
      year: '1967',
      raised: '1997',
      capacity: '8.4'
    },
    {
      id: 'dam09',
      position: { x: 371, y: 626.7 },
      title: {
        en: "Zarqa/Ma'in",
        ar: 'زرقاء ماعين'
      },
      year: '2017',
      capacity: '2'
    },
    {
      id: 'dam10',
      position: { x: 421, y: 650.4 },
      title: {
        en: 'Al Wala',
        ar: 'الواله'
      },
      year: '2002',
      capacity: '8.2'
    },
    {
      id: 'dam11',
      position: { x: 421, y: 688 },
      title: {
        en: 'Mujib',
        ar: 'الموجب'
      },
      year: '2003',
      capacity: '29.8'
    },
    {
      id: 'dam12',
      position: { x: 464.9, y: 794.8 },
      title: {
        en: 'Lajjoun',
        ar: 'اللجون'
      },
      year: '2018',
      capacity: '1'
    },
    {
      id: 'dam13',
      position: { x: 547.6, y: 790.6 },
      title: {
        en: 'Wadi Al Karak - AlQatraneh',
        ar: 'وادي الكرك - القطرانة'
      },
      year: '2017',
      capacity: '2'
    },
    {
      id: 'dam14',
      position: { x: 376.4, y: 926.1 },
      title: {
        en: 'Tannour',
        ar: 'التنور'
      },
      year: '2001',
      capacity: '16.8'
    },
    {
      id: 'dam15',
      position: { x: 168.7, y: 1257.4 },
      title: {
        en: 'Wadi Rahma',
        ar: 'وادي رحمة'
      },
      year: '2019',
      capacity: '0.5'
    }
  ]
}
